<div [formGroup]="formGroup" class="flex flex-col mat-input-container">
    @if (label) {
        <div class="hypo-input-label">
            {{ label }}
            @if (showOptionalLabel()) {
                <span class="optional"></span>
            }
            @if (tooltip) {
                <app-tooltip [text]="tooltip"></app-tooltip>
            }
        </div>
    }

    <mat-radio-group
        class="wrapped flex flex-row flex-wrap gap-3"
        formControlName="mainInput"
        [attr.data-testid]="testId">
        @for (listType of showingList; track listType; let i = $index) {
            <mat-radio-button
                [ngClass]="itemClass"
                [attr.data-testid]="testId + ':' + listType.value"
                [@fade]
                [fxFlex]="buttonsFlex"
                [value]="listType.value">
                {{ listType.label }}
            </mat-radio-button>
        }

        @if (toggleAbleOptions) {
            <div
                (click)="toggleMoreOptions()"
                [attr.data-testid]="testId + '-toggle'"
                [class.is-toggled]="showMoreOptions"
                [fxFlex]="buttonsFlex"
                [ngClass]="itemClass"
                class="show-options flex flex-row items-center justify-center gap-4">
                <!-- fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" -->
                <mat-icon>arrow_upward</mat-icon>
                @if (showMoreOptions) {
                    <span>Méně možností</span>
                } @else {
                    <span>Více možností</span>
                }
            </div>
        }
    </mat-radio-group>
    @if (input.touched) {
        @if (input.hasError('required')) {
            <mat-error>Povinný údaj</mat-error>
        }
    }
    @if (input.hasError('marriageVsApplicantCount')) {
        <mat-error>Nemůžete být v manželství sami.</mat-error>
    }
</div>
